
export class PayRollRequest {

    month?: number;
    PayrollMonth?: string;
    department?: number;
    employeeName?: string;

    constructor(month?: number,
        PayrollMonth?: string,
        department?: number,
        employeeName?: string,
    ) {
        this.month = month;
        this.PayrollMonth = PayrollMonth;
        this.department = department;
        this.employeeName = employeeName;
    }


}